module.exports = __webpack_public_path__ + "assets/b972a5b60b367c739a9b3d59a55aa12a.json";